import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_REC020_Request,
  IAPI_REC020_Response,
  IAPI_APP016_Request,
  IAPI_APP016_Response,
} from "../../../type/apiType";

// 割増金請求参照API
// API仕様書_収納・納付請求処理
const httpAPI_REC020 = async (
  param: IAPI_REC020_Request
): Promise<IAPI_REC020_Response> => {
  let res = await http.post(ApiUrl.API_REC020, {
    ...param,
  });

  return res.data;
};

// 申請状況更新API
// API仕様書_申請情報_申請状況更新
const httpAPI_APP016 = async (
  param: IAPI_APP016_Request
): Promise<IAPI_APP016_Response> => {
  let res = await http.post(ApiUrl.API_APP016, {
    ...param,
  });

  return res.data;
};

export { httpAPI_REC020, httpAPI_APP016 };
